import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AccountInfo } from "@azure/msal-browser";
import { AppError } from "../../app-store-error.types";

//****************** AUTHENTICATION ACTIONS ******************//
export const AuthenticationActions = createActionGroup({
    source: "Authentication",
    events: {
        "Initialize Authentication": emptyProps(),
        "Initialize Authentication Success": props<{ account: AccountInfo; isAuthenticated: boolean }>(),
        "Initialize Authentication Failure": props<{ error: AppError; isAuthenticated: boolean }>(),
    },
});
